import type { LocalBridgeConnection, LocalBridgeResident } from "./localBridgeApi";

export function readyPaseFirmeConnections(connections: LocalBridgeConnection[]) {
  return connections.filter((connection) =>
    connection.captureMode === "resident_allowlist"
    && connection.status === "active"
    && connection.state === "ready"
  );
}

export function enabledPaseFirmeResidents(residents: LocalBridgeResident[]) {
  return residents
    .filter((resident) => resident.enabled
      && Boolean(resident.privacyNoticeAcceptedAt)
      && Boolean(resident.customerId)
      && Boolean(resident.customer)
      && Boolean(resident.site))
    .sort((a, b) => a.displayName.localeCompare(b.displayName, "es"));
}

export function directMessageValidation(input: {
  connectionId: string;
  recipientPhone: string;
  body: string;
}) {
  if (!input.connectionId) return "Selecciona una conexión disponible.";
  if (!input.recipientPhone) return "Selecciona un residente habilitado.";
  if (!input.body.trim()) return "Escribe el mensaje que deseas enviar.";
  if (input.body.trim().length > 4_096) return "El mensaje supera el máximo de 4096 caracteres.";
  return "";
}
